import React from "react";
import { Alert, Button } from "@mui/material";
import { Typography } from "@platform/design-system";

interface CarrierOverLimitAlertProps {
  message: string;
  onEditCarriers: () => void;
}

// Shown on the Review step when a selected carrier's group now exceeds its API
// submission limit — reachable by editing Eligible Employees in Review after the
// carrier was selected under the limit. Blocks submit and points back to the
// carriers step. See ADR-037 (PB-690).
export function CarrierOverLimitAlert({
  message,
  onEditCarriers,
}: CarrierOverLimitAlertProps): React.JSX.Element {
  return (
    <Alert
      data-testid="carrier-over-limit-alert"
      severity="error"
      variant="outlined"
      action={
        // TODO(ds-button): needs manual review — outlined danger has no DS variant
        <Button
          color="error"
          variant="outlined"
          size="small"
          onClick={onEditCarriers}
        >
          Edit Carriers
        </Button>
      }
      sx={{ mb: 2 }}
    >
      <Typography variant="body-medium" color="inherit">
        {message}
      </Typography>
    </Alert>
  );
}
